import { useIntl } from 'react-intl'

function useCruiseCabinDescriptions(): Record<string, string> {
  const intl = useIntl()

  return {
    inside: intl.formatMessage({
      id: 'FFFTkhnauRD90GPNLGiJ',
      defaultMessage: 'An inside cabin is normally the most affordable option, often without a window.',
      description: 'Description of an inside cruise cabin type in the cruise section',
    }),
    oceanview: intl.formatMessage({
      id: 'LVjiLv6fys3sLZHrcXH2',
      defaultMessage: 'An oceanview cabin, often called an outside cabin, is a room with a port hole or window that looks out to sea, depending on deck and location.',
      description: 'Description of an oceanview cruise cabin type in the cruises section',
    }),
    window: intl.formatMessage({
      id: '3OS3RUV_ZtOtiIRSKNgn',
      defaultMessage: 'A window cabin is a room with a fixed picture window that looks onto the river and passing scenery, depending on deck and location.',
      description: 'Description of a window cruise cabin type in the cruise section',
    }),
    oceanview_window: intl.formatMessage({
      id: 'VoZH3u7iXryc3sTT5z_A',
      defaultMessage: 'An oceanview / window cabin is a room with a port hole or window that looks out to sea or river and passing scenery, depending on deck and location.',
      description: 'Description of an oceanview / window cruise cabin type',
    }),
    balcony: intl.formatMessage({
      id: 'ILh03y7NhJuPloYn7-Ji',
      defaultMessage: 'A balcony cabin is any cruise room with a private verandah, allowing you to take in the beautiful views and fresh air.',
      description: 'Description of a balcony cruise cabin type in the cruise section',
    }),
    suite: intl.formatMessage({
      id: 'iFFRXRbobG4TxRkcqDdR',
      defaultMessage: 'A suite is an especially large room within a cruise ship’s top tier of cabins, often with a wide window and/or private verandah.',
      description: 'Description of a suite cruise cabin type in the cruise section',
    }),
  }
}

export default useCruiseCabinDescriptions
